
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos/garantias",
      function () {
        return require("private-next-pages/servicos/garantias.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos/garantias"])
      });
    }
  